import { FilterChip } from './FilterChip'
import type { FilterCriteria } from './types'

type Props = {
  useFilterCriteria: () => FilterCriteria | undefined
  useClear: () => () => void
}

export function Clear({ useFilterCriteria, useClear }: Props) {
  const criteria = useFilterCriteria()
  const clear = useClear()
  if (!hasCriteria(criteria)) {
    return null
  }
  return (
    <FilterChip onClick={clear} color="clear">
      絞り込み条件をクリア
    </FilterChip>
  )
}

function hasCriteria(criteria?: FilterCriteria): boolean {
  if (criteria === undefined) {
    return false
  }
  const filters = [
    criteria.afternoonTea ?? false,
    criteria.buffet ?? false,
    criteria.childUses?.gradeSchoolers ?? false,
    criteria.childUses?.preSchoolers ?? false,
    criteria.freeFlow ?? false,
    criteria.seatTypes?.counter ?? false,
    criteria.seatTypes?.privateRoom ?? false,
    criteria.seatTypes?.semiPrivateRoom ?? false,
    criteria.seatTypes?.terrace ?? false,
    criteria.seatTypes?.table ?? false,
    criteria.seatTypes?.windowSide ?? false,
    criteria.smokingAllowed !== undefined,
    criteria.upperBoundPrice ?? false,
    criteria.lowerBoundPrice ?? false,
  ]
  return filters.some((f) => f)
}
